/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui';

/* ++++++++++ --------------- INVOICE PAGE - SETTINGS : STYLES --------------- ++++++++++ */
export default {
  advanced: {
    '& .collapsable.opened': {
      //maxHeight: pxToEm(5000), // commented out in case removing causes issues
      overflow: 'scroll',
    },
    '& .table': {
      padding: `${pxToEm(10)} 0`,
      '& .tableview': {
        overflow: "visible"
      },
      '& .row': {
        position: 'static'
      },
      '& .column, .singleselectdropdown': {
        color: '#061240',
        position: 'static',
        '& .active-true': {
          position: 'sticky',
          background: 'white',
          zIndex: 7
        },
        '& .active-false': {
          position: 'static',
          zIndex: 0
        }
      },
    },
    '& .singleselectdropdown': {
      color: '#afbcd5 !important'
    },
    "& .configWrapper": {
      width: '45%'
    },
    '& .flexHorizontal': {
      display: 'flex',
      flexDirection: 'row',
      gap: pxToEm(10)
    },
    '& .trashIcon': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  },
  overlay: {
    zIndex: 5,
  },
  updateSuccess: {
    color: themeV2.color.success.main
  },
  updateFailed: {
    color: themeV2.color.error.main
  }
};